<template>
  <b-navbar toggleable="md" :type="navType" :variant="navVariant">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-navbar-brand :to="{ name: 'home' }">
      time-tracker
      <div id="test">{{ test ? 'test' : '' }}</div>
    </b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item :to="{ name: 'employee', params: { id: this.$store.state.user.id } }">Mój profil</b-nav-item>
        <b-nav-item :to="{ name: 'calendar' }">Kalendarz</b-nav-item>
        <b-nav-item v-if="$is('admin', 'manager', 'hr')" :to="{ name: 'employees' }">Pracownicy</b-nav-item>
        <b-nav-item v-if="$is('admin', 'hr')" :to="{ name: 'holiday-summary' }">Urlopy</b-nav-item>
        <b-nav-item v-if="$is('admin', 'equipment')" :to="{ name: 'equipment' }">Wyposażenie</b-nav-item>
        <b-nav-item v-if="$is('admin', 'manager', 'hr')" :to="{ name: 'panels' }">Ustawienia</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <!-- Using button-content slot -->
          <template slot="button-content">
            <em>{{ $store.state.user.firstName }} {{ $store.state.user.lastName }}</em>
          </template>
          <b-dropdown-item :to="{ name: 'settings' }" href="#">Ustawienia</b-dropdown-item>
          <b-dropdown-item @click="logout" :to="{ name: 'login' }">Wyloguj się</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      test: '',
      navType: 'dark',
      navVariant: 'info'
    };
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
    }
  },
  mounted() {
    this.test = process.env.VUE_APP_TEST;
    this.navType = this.test ? 'light' : 'dark';
    this.navVariant = this.test ? 'warning' : 'info';
  }
};
</script>

<style>
#test {
  font-size: 0.6em;
  display: inline-block;
}
</style>
